import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useMemo } from 'react'

import styles from './ServiceDeliveryReadMode.module.scss'

interface IServiceDeliveryReadModeProps {
  isServiceDelivery: Nullable<boolean>
}

export const ServiceDeliveryReadMode: FC<IServiceDeliveryReadModeProps> = ({
  isServiceDelivery,
}) => {
  const serviceDeliveryMessage = useMemo(() => {
    if (isServiceDelivery === null) {
      return '-'
    }

    return isServiceDelivery ? 'Yes' : 'No'
  }, [isServiceDelivery])

  return <div className={styles.root}>{serviceDeliveryMessage}</div>
}
